// extracted by mini-css-extract-plugin
export default {"appicons":"Modal_2_3_OpenCamera_appicons__PuIfQ"};